<ng-template #content>
  <ng-content />
</ng-template>

@if (removable) {
  <div>
    <span class="z-fx-sc">
      <span [class.zef-line-through]="invalid">
        <ng-container *ngTemplateOutlet="content" />
      </span>
      <button
        mat-icon-button
        class="zef-transparent-button chip-close"
        matTooltip="Remove value"
        i18n-matTooltip
        (click)="$event.stopPropagation(); remove.emit()"
      >
        <mat-icon color="secondary" class="zef-icon-small">close</mat-icon>
      </button>
    </span>
  </div>
} @else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}
